import './App.css';
import Formation from "./components/Formation";
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Video from './components/Video';
import Text from './components/text';
import Notefound from './pages/Notefound';
import Listformation from './pages/Listformation';
import Navbar from './components/navbar';
import Createformation from './pages/Createformation';
import Forums from './pages/Forums';
import Forum from './pages/Forum';
import Createroom from './pages/Createroom';
import Login from './pages/Login';
import Regester from './pages/Regester';

import { AuthProvider } from "./context/Authcontext";

import ProtectedRoute,{AdminTeacherrouteRoute} from './utils/privateroute';
import Modifierforation from './pages/Modifierforation';
import Presentationformation from './pages/Presentationformation';
import Profile from './pages/profile';
import NotAllowedPage from './pages/Notallowedpage';
import Alltrainings from './pages/Alltrainings';
import Allformationcategorie from './pages/Allformationcategorie';
import Previewvideo from './pages/previewvideo';
import Previewtext from './pages/previewtext';
import Verifyemail from './pages/Verifyemail';

function App() {
  return (
    <div className="container">

    <AuthProvider>

      <Navbar/>

     <Routes>
          
          
          
          <Route  path="/" element= {<Home/>} />
          <Route  path="/verifyemail" element= {<Verifyemail/>} />
          <Route  path="/formations" element= {<Alltrainings/>} />
          <Route  path="/formations/categorie/:id" element= {<Allformationcategorie/>} />

          <Route path='/formation'>
            
          <Route  index element= {<ProtectedRoute><Listformation/></ProtectedRoute>} />
          <Route  path="modifier/:id" element= { <AdminTeacherrouteRoute> <Modifierforation/></AdminTeacherrouteRoute> }/>
          <Route  path="description/:id" element= {<Presentationformation/>}/>

          <Route path=':id'>

          <Route index element= {<Formation/>} />
          <Route  path="rooms" element= {<Forums/>} />


          <Route  path="createroom" element= { <Createroom/> } />
          <Route  path="rooms/:id2" element= {<Forum/>} />
          <Route  path="video/:id2" element= {<Video/>} />
          <Route  path="previewvideo/:id2" element= {<Previewvideo/>} />
          <Route  path="text/:id2" element= {<Text/>} />
          <Route  path="previewtext/:id2" element= {<Previewtext/>} />

          </Route>
          </Route>
          <Route  path="/createformation" element= {<AdminTeacherrouteRoute><Createformation/></AdminTeacherrouteRoute>} />
          {/* Authentification */}
          <Route  path="/login" element= {<Login/>} />
          <Route  path="/register" element= {<Regester/>} />
          {/* profile */}
          <Route  path="/profile/:id" element= {<ProtectedRoute><Profile/></ProtectedRoute>} />
          {/* Notefound */}
          <Route  path="/notallowed" element= {<NotAllowedPage/>} />
          <Route  path="*" element= {<Notefound/>} />

        </Routes>



        </AuthProvider>
    </div>
  );
}

export default App;


